import React, { useEffect, useState } from "react"
import TableGrid from "../components/TableGrid"
import TreeGrid from "../components/TreeGrid"
import ModalVistas from "../components/ModalVistas"
import AdminVistas from "../components/AdminVistas"
import ModalPerfil from "../components/ModalPerfil"
import MyGrid from "../components/MyGrid"
import {
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Button,
  Row,
  Col,
} from "reactstrap"
import classnames from "classnames"

import { getProfiles, getVistas } from "../requests/req-system"

//Layout
import Main from "../Layouts/Main"
import { Header_Vistas, Header_Vistas_Sub } from "../dicionarios"

const Vistas = () => {
  const [profiles, setProfiles] = useState([])
  const [vistas_, setVistas] = useState(null)
  const [visibleModal, setVisibleModal] = useState(false)
  const [dataInfo, setDataInfo] = useState({})
  const [addChild, setAddChild] = useState(false)
  const [isEdit, setIsEdit] = useState(false)
  const [isPadre, setIsPadre] = useState(false)
  const [isEditChild, setIsEditChild] = useState(false)
  const [activeTab, setActiveTab] = useState("1")

  const [visibleAdmin, setVisibleAdmin] = useState(false)
  const [vistaPerfil, setVistaPerfil] = useState(false)

  const toggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab)
  }

  useEffect(() => {
    GetProfile()
    GetVistas_()
  }, [])

  const GetProfile = async () => {
    let response = await getProfiles()
    setProfiles(response)
  }

  const GetVistas_ = async () => {
    let response = await getVistas()
    let newView = []
    for (let index = 0; index < response.length; index++) {
      let hijos = response[index].children.map((item) => item.data)
      delete response[index].data.children
      newView.push({ ...response[index].data, children: hijos })
    }
    console.log(newView)
    setVistas(newView)
  }

  const addVistas = (data) => {
    setDataInfo(data)
    setAddChild(true)
    setIsEdit(false)
    setIsPadre(false)

    setVisibleModal(true)
  }

  const editVista = (data) => {
    setDataInfo(data)
    setIsEdit(true)
    setAddChild(false)
    setIsPadre(false)
    if (data.vistaPdre === 0) {
      setIsEditChild(false)
    } else {
      setIsEditChild(true)
    }

    setVisibleModal(true)
  }

  const onConfigOpen = (data) => {
    setDataInfo(data)
    setVisibleAdmin(true)
  }

  const addPerfil = () => {
    setVistaPerfil(true)
  }

  const editPerfil = (data) => {
    setDataInfo(data)
    setVistaPerfil(true)
  }

  return (
    <Main>
      {" "}
      <div className="dv_vistas">
        <div className="dv_Btn_Lbl_Rpt">
          <h2>Administración vistas y perfiles</h2>
        </div>

        <div className={"tabs"}>
          <Nav tabs>
            <NavItem>
              <NavLink
                className={classnames({ active: activeTab === "1" })}
                onClick={() => {
                  toggle("1")
                }}>
                Administración de Vistas
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={classnames({ active: activeTab === "2" })}
                onClick={() => {
                  toggle("2")
                }}>
                Perfiles
              </NavLink>
            </NavItem>
          </Nav>
          <TabContent activeTab={activeTab}>
            <TabPane tabId="1">
              <Row className={"panel-btn"}>
                <Col sm="8" lg="8" />
                <Col sm="1.5" lg="1.5">
                  <Button className={"btn-update"} onClick={() => getVistas()}>
                    <span>ACTUALIZAR</span>
                  </Button>
                </Col>
                <Col sm="1.5" lg="1.5">
                  <Button
                    className={"btn-add"}
                    onClick={() => {
                      setDataInfo({})
                      setIsEdit(false)
                      setAddChild(false)
                      setIsPadre(true)
                      setVisibleModal(true)
                    }}>
                    <span>AGREGAR</span>
                  </Button>
                </Col>
              </Row>
              <Row>
                <Col sm="12">
                  <div className={"tab_div"}>
                    {vistas_ ? (
                      <MyGrid
                        columns={Header_Vistas}
                        data={vistas_}
                        config={{
                          scrollX: true,
                          tree: true,
                          treeColumns: Header_Vistas_Sub,
                          nodeTreeData: "children",
                          exportFile: false,
                          width: "100%",
                        }}
                        funtions={{
                          addVistas: addVistas,
                          editVista: editVista,
                        }}
                      />
                    ) : null}
                  </div>
                </Col>
              </Row>
            </TabPane>
            <TabPane tabId="2">
              <Row className={"panel-btn"}>
                <Col sm="9" lg="8" />
                <Col sm="1.5" lg="1.5">
                  <Button
                    className={"btn-update"}
                    onClick={() => getProfiles()}>
                    <span>ACTUALIZAR</span>
                  </Button>
                </Col>
                <Col sm="1.5" lg="1.5">
                  <Button className={"btn-add"} onClick={() => addPerfil()}>
                    <span>AGREGAR</span>
                  </Button>
                </Col>
              </Row>
              <Row>
                <Col sm="12">
                  <div className={"tab_div"}>
                    {profiles ? (
                      <TableGrid
                        detalle={profiles}
                        filterVisibles={true}
                        onConfig={onConfigOpen}
                        onEdit={editPerfil}
                      />
                    ) : null}
                  </div>
                </Col>
              </Row>
            </TabPane>
          </TabContent>
          {visibleModal ? (
            <ModalVistas
              visible={visibleModal}
              isaddChild={addChild}
              isEdit={isEdit}
              isEditChild={isEditChild}
              data={dataInfo}
              isPadre={isPadre}
              onClosed={() => {
                setVisibleModal(false)
                setDataInfo({})
                setIsEdit(false)
                setAddChild(false)
              }}
              onSucces={() => GetVistas_()}
            />
          ) : null}

          {visibleAdmin ? (
            <AdminVistas
              visible={visibleAdmin}
              onClosed={() => {
                setDataInfo({})
                setVisibleAdmin(false)
              }}
              data={dataInfo}
            />
          ) : null}

          {vistaPerfil ? (
            <ModalPerfil
              visible={vistaPerfil}
              data={dataInfo}
              onClosed={() => {
                setVistaPerfil(false)
              }}
              onSucces={() => GetProfile()}
            />
          ) : null}
        </div>
      </div>
    </Main>
  )
}

export default Vistas
